import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

const RowCount = z.number().int().nonnegative();
const RowNumber = z.number().int().positive();

const CostImportProductRowSchema_ = z.object({
  rowNumber: RowNumber,
  productId: productIdFormat.schema,
  sku: z.string().nullable(),
  title: z.string(),
  /** Cost before the import, in the shop currency's major units. */
  oldCost: z.number().nullable(),
  newCost: z.number(),
});
export const CostImportProductRowSchema: z.ZodType<CostImportProductRowSchema> =
  CostImportProductRowSchema_;
export interface CostImportProductRowSchema extends z.infer<
  typeof CostImportProductRowSchema_
> {}

/** A row the import skips, with its cells as uploaded so it can be fixed. */
const CostImportProblemRowSchema_ = z.object({
  rowNumber: RowNumber,
  productId: z.string(),
  sku: z.string(),
  cost: z.string(),
  issue: z.string(),
});
export const CostImportProblemRowSchema: z.ZodType<CostImportProblemRowSchema> =
  CostImportProblemRowSchema_;
export interface CostImportProblemRowSchema extends z.infer<
  typeof CostImportProblemRowSchema_
> {}

const CostImportSummarySchema_ = z.object({
  /** Problems with the whole file, such as a missing Cost column. */
  parseErrors: z.array(z.string()),
  currency: z.string(),
  /** `updates` holds at most this many rows; counts are exact. */
  sampleLimit: RowCount,
  counts: z.object({
    rows: RowCount,
    update: RowCount,
    unchanged: RowCount,
    blankCost: RowCount,
    unmatched: RowCount,
    ambiguous: RowCount,
    invalid: RowCount,
    duplicate: RowCount,
  }),
  updates: z.array(CostImportProductRowSchema),
  /** Every skipped row except blank costs, in file order. */
  problems: z.array(CostImportProblemRowSchema),
});
export const CostImportSummarySchema: z.ZodType<CostImportSummarySchema> =
  CostImportSummarySchema_;
export interface CostImportSummarySchema extends z.infer<
  typeof CostImportSummarySchema_
> {}

/** Reads a cost CSV (sent as the first file) and says what applying it would do. */
export const previewCostImport = {
  name: "previewCostImport" as const,
  input: z.object({}),
  output: CostImportSummarySchema,
};
